import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const Vitals: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-accent-dark-blue-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            className="w-12 h-12 fill-white "
                        >
                            <path d="M476.7 20.35c-37.5-30.63-95.49-26.26-131.9 10.25l-239.6 241.2C99.36 277.8 96.02 285.9 96.02 294.4l.0006 87.71l-88.99 89.02c-9.375 9.377-9.375 24.63 0 33.88c9.373 9.377 24.62 9.377 33.87 0l88.99-89.02l86.64-.0002c8.467 0 16.59-3.355 22.59-9.332l244.9-243.1C518.9 127.8 526.2 61.11 476.7 20.35zM450.1 128.6l-240.1 239.4H144V300.9l35-35.27l33.67 33.67C215.8 302.4 219.9 304 224 304s8.188-1.562 11.31-4.688c6.25-6.25 6.25-16.38 0-22.62L201.6 242.9l41.21-41.54l33.92 33.92C279.8 238.4 283.9 240 288 240s8.188-1.562 11.31-4.688c6.25-6.25 6.25-16.38 0-22.62l-34.01-34.01l41.21-41.54l34.17 34.17C343.8 174.4 347.9 176 352 176s8.188-1.562 11.31-4.688c6.25-6.25 6.25-16.38 0-22.62l-34.25-34.25l49.69-50.07c19.12-19.13 48.75-22.13 67.37-7C471.6 78.36 467.2 111.5 450.1 128.6z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={
                    <div className="font-700" id="vitals-left-id">
                        {sectionName || 'Vitals'}
                    </div>
                }
                key="vitals "
            >
                <p className="mr-16 space-y-2">
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    vitals_in_unbold: !rxConfig?.vitals_in_unbold,
                                });
                            }}
                        >
                            <span>Make the vitals name bold</span>
                            <Checkbox checked={!rxConfig?.vitals_in_unbold}></Checkbox>
                        </p>
                    </div>

                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    bullets_config: {
                                        ...rxConfig?.bullets_config,
                                        ['vitals']: !rxConfig?.bullets_config?.['vitals'],
                                    },
                                    tabular_config: {
                                        ...rxConfig?.tabular_config,
                                        ['vitals']: false,
                                    },
                                });
                            }}
                        >
                            <span>Use bullet points</span>
                            <Checkbox
                                checked={
                                    rxConfig?.bullets_config?.['vitals'] &&
                                    !rxConfig?.tabular_config?.['vitals']
                                }
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    bullets_config: {
                                        ...rxConfig?.bullets_config,
                                        ['vitals']: false,
                                    },
                                    tabular_config: {
                                        ...rxConfig?.tabular_config,
                                        ['vitals']: !rxConfig?.tabular_config?.['vitals'],
                                    },
                                });
                            }}
                        >
                            <span>Use tabular format</span>
                            <Checkbox
                                checked={
                                    !rxConfig?.bullets_config?.['vitals'] &&
                                    rxConfig?.tabular_config?.['vitals']
                                }
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.vitals_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        vitals_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            vitals_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    {!(
                        !rxConfig?.bullets_config?.['vitals'] &&
                        rxConfig?.tabular_config?.['vitals']
                    ) ? (
                        <>
                            <div className="flex items-center justify-between">
                                <div>Key Elements</div>{' '}
                                <div className="flex space-x-12">
                                    <input
                                        type="color"
                                        id="head"
                                        name="head"
                                        value={rxConfig?.vitals_name_color || '#000000'}
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                vitals_name_color: e.target.value,
                                            });
                                        }}
                                        className="circular-color-input"
                                    />

                                    <AntTooltip content="Reset">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            onClick={() => {
                                                saveRxConfigInState({
                                                    vitals_name_color: '',
                                                });
                                            }}
                                        >
                                            <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                        </svg>
                                    </AntTooltip>
                                </div>
                            </div>
                            <div className="flex items-center justify-between">
                                <div>Properties</div>{' '}
                                <div className="flex space-x-12">
                                    <input
                                        type="color"
                                        id="head"
                                        name="head"
                                        value={rxConfig?.vitals_properties_color || '#000000'}
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                vitals_properties_color: e.target.value,
                                            });
                                        }}
                                        className="circular-color-input"
                                    />

                                    <AntTooltip content="Reset">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            onClick={() => {
                                                saveRxConfigInState({
                                                    vitals_properties_color: '',
                                                });
                                            }}
                                        >
                                            <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                        </svg>
                                    </AntTooltip>
                                </div>
                            </div>
                        </>
                    ) : (
                        <></>
                    )}
                </p>
            </Panel>
        </Collapse>
    );
};

export default Vitals;
